module.exports = __webpack_public_path__ + "img/ka_get.b640c8b.png";